import { gql } from "@apollo/client";

const SCHEMAS_QUERY = gql`
  query schemas {
    sbs_schemas {
      name
    }
  }
`;

const SCHEMA_BY_NAME_QUERY = gql`
  query schema_by_name($name: String!) {
    sbs_schema(name: $name) {
      name
      text
    }
  }
`;

export { SCHEMAS_QUERY, SCHEMA_BY_NAME_QUERY };
